import { detectCurrency, saveCurrencyPreference, type CurrencyCode } from '$lib/utils/pricing';

/**
 * Global pricing state for the application
 * Uses Svelte 5 runes for reactive state
 */
class PricingState {
	selectedCurrency = $state<CurrencyCode>('INR');
	isTransitioning = $state(false);

	constructor() {
		// Initialize currency from detection logic
		this.selectedCurrency = detectCurrency();
	}

	setCurrency(currency: CurrencyCode) {
		if (this.selectedCurrency === currency) return;

		// Add transition state for visual feedback
		this.isTransitioning = true;

		// Update currency
		this.selectedCurrency = currency;
		saveCurrencyPreference(currency);

		// Clear transition state after animation
		setTimeout(() => {
			this.isTransitioning = false;
		}, 300);
	}
}

export const pricingState = new PricingState();
